"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LabelValueDisplay = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const Container = (0, _styles.styled)('div')({
  display: 'flex',
  flexWrap: 'nowrap',
  height: '100%'
});
const COMMON_CELL_STYLES = theme => ({
  display: 'flex',
  padding: theme.spacing(1),
  borderBottom: "solid 1px ".concat(theme.palette.border.gray)
});
const LabelCell = (0, _styles.styled)(_material.Typography)(_ref => {
  let {
    theme
  } = _ref;
  return _objectSpread(_objectSpread({}, COMMON_CELL_STYLES(theme)), {}, {
    background: theme.palette.table.header.primary.main,
    color: theme.palette.table.header.primary.contrastText
  });
});
const ValueCell = (0, _styles.styled)(_material.Typography)(_ref2 => {
  let {
    theme
  } = _ref2;
  return _objectSpread({}, COMMON_CELL_STYLES(theme));
});

/**
 * ラベルバリュー表示部品
 * @prop {node} [label] -ラベル部分に表示する内容
 * @prop {node} [value] -値部分に表示する内容
 * @prop {number} [labelWidth] -ラベル部分の幅 (default: 200)
 */
const LabelValueDisplay = _ref3 => {
  let {
    label,
    value,
    labelWidth = 200
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(LabelCell, {
    component: "div",
    variant: "body2",
    style: {
      width: labelWidth
    }
  }, label), /*#__PURE__*/_react.default.createElement(ValueCell, {
    component: "div",
    variant: "body2",
    style: {
      width: "calc(100% - ".concat(labelWidth, "px)")
    }
  }, value));
};
exports.LabelValueDisplay = LabelValueDisplay;
LabelValueDisplay.propTypes = {
  label: _propTypes.default.node,
  value: _propTypes.default.node,
  labelWidth: _propTypes.default.number
};
var _default = exports.default = (0, _reactIntl.injectIntl)(LabelValueDisplay);